import { YfmFilePaste } from './YfmFilePaste';
import { YfmFileWidget } from './YfmFileWidget';
export const YfmFileAdditions = (builder, opts = {}) => {
    builder.use(YfmFileWidget, opts);
    if (opts.fileUploadHandler) {
        builder.use(YfmFilePaste, {
            fileUploadHandler: opts.fileUploadHandler,
            needToSetDimensionsForUploadedImages: Boolean(opts.needToSetDimensionsForUploadedImages),
        });
    }
};
